/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyWalletAOpenIcon20Solid = forwardRef('MoneyWalletAOpenIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1 5.702a3.5 3.5 0 0 1 2.614-3.386L12.12.092A1.5 1.5 0 0 1 14 1.542V4h.51-9.76a.75.75 0 0 0 0 1.5h12.623c.395.567.627 1.256.627 2v.51c-.05-.007-.1-.01-.15-.01H13a3 3 0 1 0 0 6h4.85c.05 0 .1-.003.15-.01v.51a3.5 3.5 0 0 1-3.5 3.5h-10A3.5 3.5 0 0 1 1 14.5V5.702Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 12.85v-3.7a.15.15 0 0 0-.15-.15H13a2 2 0 1 0 0 4h4.85a.15.15 0 0 0 .15-.15ZM15 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" })));
});
